import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { TaskServices, TaskServiceConfiguration, TaskServicesGlobalConfiguration } from '@/views/configuration/taskServices';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const meta = {
  layout: 'TreeView',
  treePath: '/configuration/taskServices',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Task Services'
};

export const TaskServicesRoutes = [
  {
    ...Configuration.TaskServices.TaskServices,
    components: {
      default: TaskServices,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.TaskServices.TaskServiceConfiguration,
    components: {
      default: TaskServiceConfiguration,
      treeView: ConfigurationTreeView
    },
    meta
  },
  {
    ...Configuration.TaskServices.TaskServicesGlobalConfiguration,
    components: {
      default: TaskServicesGlobalConfiguration,
      treeView: ConfigurationTreeView
    },
    meta
  }
];
